import { lazy } from 'react';

const InvoicedTransformerConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/material-invoiced',
			component: lazy(() => import('./InvoicedContainer'))
		}
	]
};

export default InvoicedTransformerConfig;



